/**
 * The four facts a hesitant customer needs right above the total — the
 * open Iris recommendation from 2026-08-24 ("reassurance above the total").
 *
 * Wording is the knowledge base's: "no credit check, no interest, no hidden
 * fees", price protection from the deposit, and Defera Credit framed as
 * eligibility ("select bookings"), never as a mechanism (desk Hard Rule #13).
 */
import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';
import { CHECKOUT_REASSURANCE } from './checkoutReassuranceContent';


export default function CheckoutReassuranceStrip({ className }) {
  return (
    <ul
      aria-label="Why booking with Defera is safe"
      className={cn('flex flex-wrap items-center justify-center gap-x-2 gap-y-2 list-none m-0 p-0', className)}
    >
      {CHECKOUT_REASSURANCE.map(({ id, icon: Icon, label }) => (
        <li
          key={id}
          className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 text-[12px] font-normal text-white/80"
        >
          <Icon className="h-3.5 w-3.5 text-brand-300" aria-hidden />
          {label}
        </li>
      ))}
    </ul>
  );
}

CheckoutReassuranceStrip.propTypes = { className: PropTypes.string };
